import Vue from 'vue'
import Router from 'vue-router'
// components
import InputInventory from '@/components/InputInventory'
import Top from '@/components/Top'
import Login from '@/components/Login'
import TenpoSelect from '@/components/TenpoSelect'
import ProcessingMaterial from '@/components/ProcessingMaterial'
import RegistrationProduct from '../components/RegistrationProduct.vue'
// store
import Store from '@/store/index.js'

Vue.use(Router);

const routes = [
  {
    path: '/',
    name: 'Login',
    component: Login
  },
  {
    path: '/Top',
    name: 'Top',
    component: Top,
    meta: { requiresAuth: true }
  },
  {
    path: '/InputInventory',
    name: 'InputInventory',
    component: InputInventory,
    meta: { requiresAuth: true }
  },
  {
    path: '/TenpoSelect',
    name: 'TenpoSelect',
    component: TenpoSelect,
    meta: { requiresAuth: true }
  },
  {
    path: '/ProcessingMaterial',
    name: 'ProcessingMaterial',
    component: ProcessingMaterial,
    meta: { requiresAuth: true }
  },
  {
    path: '/RegistrationProduct',
    name: 'RegistrationProduct',
    component: RegistrationProduct,
    meta: { requiresAuth: true }
  },
  {
    path: '*',
    name: 'NotFound',
    component: Login
  },
];

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth) && !Store.state.api_token) {
    next({ path: '/login', query: { redirect: to.fullPath } });
  } else {
    next();
  }
});

export default router;